// ***************************************
// tgfEffects
//
// This object contains all available effects
// for components. Feel free to extend
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 17-6-2015
// ***************************************
import { tbEase } from "../engine/tbEase";
export var tgfEffects = {};
// Return the effect with the given name
tgfEffects.effect = function (name) {
    "use strict";
    switch (name) {
        case "nothing": return tgfEffects.nothing;
        case "show": return tgfEffects.show;
        case "hide": return tgfEffects.hide;
        case "fadeIn": return tgfEffects.fadeIn;
        case "fadeOut": return tgfEffects.fadeOut;
        case "move": return tgfEffects.move;
        case "scale": return tgfEffects.scale;
        case "rotate": return tgfEffects.rotate;
        case "alpha": return tgfEffects.alpha;
        case "transform": return tgfEffects.transform;
        case "blink": return tgfEffects.blink;
        default: return tgfEffects.nothing;
    }
};
// An effect that does absolutely nothing
tgfEffects.nothing = function (component, effect, time) {
    "use strict";
};
// Simply showing the components
tgfEffects.show = function (component, effect, time) {
    "use strict";
    component.setAlpha(1);
};
// Simply hiding the components
tgfEffects.hide = function (component, effect, time) {
    "use strict";
    component.setAlpha(0);
};
// Simple effect to make components appear using alpha
tgfEffects.fadeIn = function (component, effect, time) {
    "use strict";
    var ease = effect.ease === undefined ? tbEase.easeLinear : effect.ease;
    component.setAlpha(ease(time, 0, 1, effect.duration, effect.easeArgument));
};
// Simple effect to make components appear using alpha
tgfEffects.fadeOut = function (component, effect, time) {
    "use strict";
    var ease = effect.ease === undefined ? tbEase.easeLinear : effect.ease;
    component.setAlpha(ease(time, 1, -1, effect.duration, effect.easeArgument));
};
// Simple effect to make components move
tgfEffects.move = function (component, effect, time) {
    "use strict";
    var ease = effect.ease === undefined ? tbEase.easeLinear : effect.ease, easeArgument = effect.easeArgument === undefined ? undefined : effect.easeArgument, startX = effect.startX === undefined ? 0 : effect.startX, endX = effect.endX === undefined ? 0 : effect.endX, startY = effect.startY === undefined ? 0 : effect.startY, endY = effect.endY === undefined ? 0 : effect.endY;
    var x = (effect.startX !== undefined || effect.endX !== undefined) ?
        ease(time, startX, endX - startX, effect.duration, easeArgument) :
        component.x;
    var y = (effect.startY !== undefined || effect.endY !== undefined) ?
        ease(time, startY, endY - startY, effect.duration, easeArgument) :
        component.y;
    component.setPosition(x, y);
};
// Simple effect to make components rotate
tgfEffects.rotate = function (component, effect, time) {
    "use strict";
    var ease = effect.ease === undefined ? tbEase.easeLinear : effect.ease, easeArgument = effect.easeArgument === undefined ? undefined : effect.easeArgument, startAngle = effect.startAngle === undefined ? 0 : effect.startAngle, endAngle = effect.endAngle === undefined ? 0 : effect.endAngle;
    component.setAngle(ease(time, startAngle, endAngle - startAngle, effect.duration, easeArgument));
};
// Simple effect to make components scale
tgfEffects.scale = function (component, effect, time) {
    "use strict";
    var ease = effect.ease === undefined ? tbEase.easeLinear : effect.ease, easeArgument = effect.easeArgument === undefined ? undefined : effect.easeArgument, startScale = effect.startScale === undefined ? 1 : effect.startScale, endScale = effect.endScale === undefined ? 1 : effect.endScale;
    var scale = ease(time, startScale, endScale - startScale, effect.duration, easeArgument);
    component.setScale(scale, scale);
};
// Simple effect to change the alpha of the components
tgfEffects.alpha = function (component, effect, time) {
    "use strict";
    var ease = effect.ease === undefined ? tbEase.easeLinear : effect.ease, easeArgument = effect.easeArgument === undefined ? undefined : effect.easeArgument, startAlpha = effect.startAlpha === undefined ? 1 : effect.startAlpha, endAlpha = effect.endAlpha === undefined ? 1 : effect.endAlpha;
    component.setAlpha(ease(time, startAlpha, endAlpha - startAlpha, effect.duration, easeArgument));
};
// Effect to make components transform, with alpha
tgfEffects.transform = function (component, effect, time) {
    "use strict";
    var ease = effect.ease === undefined ? tbEase.easeLinear : effect.ease, easeArgument = effect.easeArgument === undefined ? undefined : effect.easeArgument, startX = effect.startX === undefined ? 0 : effect.startX, endX = effect.endX === undefined ? 0 : effect.endX, startY = effect.startY === undefined ? 0 : effect.startY, endY = effect.endY === undefined ? 0 : effect.endY, easeMove = effect.easeMove === undefined ? ease : effect.easeMove, easeMoveArgument = effect.easeMoveArgument === undefined ? easeArgument : effect.easeMoveArgument, startScale = effect.startScale === undefined ? 1 : effect.startScale, endScale = effect.endScale === undefined ? 1 : effect.endScale, easeScale = effect.easeScale === undefined ? ease : effect.easeScale, easeScaleArgument = effect.easeScaleArgument === undefined ? easeArgument : effect.easeScaleArgument, startAngle = effect.startAngle === undefined ? 0 : effect.startAngle, endAngle = effect.endAngle === undefined ? 0 : effect.endAngle, easeRotate = effect.easeRotate === undefined ? ease : effect.easeRotate, easeRotateArgument = effect.easeRotateArgument === undefined ? easeArgument : effect.easeRotateArgument, startAlpha = effect.startAlpha === undefined ? 1 : effect.startAlpha, endAlpha = effect.endAlpha === undefined ? 1 : effect.endAlpha, easeAlpha = effect.easeAlpha === undefined ? ease : effect.easeAlpha, easeAlphaArgument = effect.easeAlphaArgument === undefined ? easeArgument : effect.easeAlphaArgument;
    var x = easeMove(time, startX, endX - startX, effect.duration, easeMoveArgument);
    var y = easeMove(time, startY, endY - startY, effect.duration, easeMoveArgument);
    component.setPosition(x, y);
    var scale = easeScale(time, startScale, endScale - startScale, effect.duration, easeScaleArgument);
    component.setScale(scale, scale);
    component.setAngle(easeRotate(time, startAngle, endAngle - startAngle, effect.duration, easeRotateArgument));
    component.setAlpha(easeAlpha(time, startAlpha, endAlpha - startAlpha, effect.duration, easeAlphaArgument));
};
// Blinking effect
tgfEffects.blink = function (component, effect, time) {
    "use strict";
    var frequency = effect.frequency === undefined ? 1 : effect.frequency, fade = effect.fade === undefined ? 0 : effect.fade, stepTime = 1 / (2 * frequency), step = Math.floor(time / stepTime), on = step % 2 === 0, prog = time % stepTime;
    if (on) {
        component.setAlpha(Math.min(1, prog / fade));
    }
    else {
        component.setAlpha(1 - Math.min(1, prog / fade));
    }
};
